import PropTypes from 'prop-types'
import { RadioGroup } from '@components/ui/radio-group'
import { AdasRadio } from './AdasRadio'
import { cn } from 'lib/utils'

export const AdasRadioGroup = ({
  children,
  options,
  value,
  onChange,
  row,
  className,
  name,
  // disabled is applied per-item when options are rendered
  disabled,
  // eslint-disable-next-line no-unused-vars
  sx,
  ...props
}) => (
  <RadioGroup
    value={value !== undefined && value !== null ? String(value) : value}
    onValueChange={(val) => onChange && onChange({ target: { value: val, name, type: 'radio' } })}
    className={cn(row ? 'flex flex-row gap-4 flex-wrap' : 'flex flex-col gap-2', className)}
    {...props}
  >
    {options
      ? options.map((option, i) => (
          <AdasRadio
            key={`${option.label}_${i}`}
            value={option.value !== undefined && option.value !== null ? String(option.value) : option.value}
            label={option.label}
            disabled={disabled}
          />
        ))
      : children}
  </RadioGroup>
)

AdasRadioGroup.propTypes = {
  children: PropTypes.node,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
    })
  ),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  onChange: PropTypes.func,
  row: PropTypes.bool,
  className: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool
}
